import { useMemo } from "react"
import { useFormikContext, getIn} from "formik"
import * as Yup from 'yup'
import { 
	FormikFileUpload,
	ApplicationFileDownload,
  FormikNotesArea
} from "../../../../../../components/widgets"
import { sortBy } from "lodash"
	
export const initVerifyDOCValues = {
	docModels: [],
	note: '',
	noteAttachments: [],      
}

export const DLMVerifyDOCSchema = Yup.object({
	docModels: Yup.array().of(
		Yup.object().shape({
			docId: Yup.number().integer().label('DOC Id'),
			docAttachmentId: Yup.number().integer().moreThan(0,'DOC required').required().label('DOC Attachment'),
			docAttachmentIdAttachmentName: Yup.string().trim(),
		})
	).min(1, 'DOC Required').required(),    
	note: Yup.string().trim().label('Note'),  
	noteAttachments: Yup.array(),
})


const DLMVerifyDOCForm = () => {
	
	const { values, validateField } = useFormikContext();
	const { docs } = useMemo(() => {		
		return { docs: values ? getIn(values, 'docModels') : []};
	}, [values]);

	return (
	<>
	<h4>Upload Actual DOC:</h4>
	<div className='separator border-gray-200 mb-2'></div>        
	<div className="mh-300px overflow-auto pe-4"> {
	sortBy(docs, 'cbRef').map((docModel: any, idx: number) => (
		<div key={`setDOCrow_${idx}`} className="row">
			<div className="col-5 py-2">        
				{ docModel.signedDOCFile && 
				<>
				<div className="text-muted fs-7">Signed DOC</div>
				<ApplicationFileDownload file={docModel.signedDOCFile} />
				</>
				} 
			</div>              
			<FormikFileUpload 
				size="7" 
				label={`${docModel?.cbRef ? docModel.cbRef : 'Actual DOC'}`} 
				name={`docModels.${idx}.docAttachmentId`} 
				acceptFiles="UserFileFormats" 
				required={true}   
				subTitle="Upload actual DOC here."   
				onUpdateFunc={ () => {
					validateField('docModels');
				}}                   
			/>
		</div>
	))}
	</div>            
	<div className='separator border-gray-200 my-4'></div> 
  <FormikNotesArea />	
	</>
	)
}

export { DLMVerifyDOCForm }